// Import necessary components from React and React Router
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './cursor.css'

// Import your page components
import ProjectsPage from './pages/projectspage/ProjectsPage';
import HomePage from './pages/homepage/HomePage';
import './App.scss'
import ScrollToTop from './components/ScrollTop/scrolltop';
import NaturePage from './pages/nature/NaturePage';

const App = () => {
  
  return (
    <Router>
      <div className="main-container">
        {/* Define Routes */}
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:id" element={<ProjectsPage />} />
          <Route path="/nature" element={<NaturePage/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
